var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.09,
    height: 48.92,
    viewBox: "0 0 42.09 48.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diary-icon",
    transform: "translate(-14.54 -7.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    d: "M56.6,24.04H53.46V11.99a4.955,4.955,0,0,0-4.95-4.95H19.49a4.955,4.955,0,0,0-4.95,4.95V51.01a4.955,4.955,0,0,0,4.95,4.95H48.51a4.955,4.955,0,0,0,4.95-4.95V38.96h2.19l.98-.03V25.03l-.03-.98ZM51.55,51.01a3.034,3.034,0,0,1-3.03,3.03H19.49a3.034,3.034,0,0,1-3.03-3.03V11.99a3.034,3.034,0,0,1,3.03-3.03H21.5V19.5l5.5-4,5.5,4V8.96H48.51a3.034,3.034,0,0,1,3.03,3.03V24.04H39.94a6.406,6.406,0,0,0-6.4,6.4v2.1a6.406,6.406,0,0,0,6.4,6.4h11.6V50.99Zm3.17-13.97H39.96a4.49,4.49,0,0,1-4.49-4.49v-2.1a4.49,4.49,0,0,1,4.49-4.49H54.72V37.05Z",
    fill: "#d1d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    d: "M45.86,35.5l-.98-4a2.18,2.18,0,1,0-2.4,0l-.98,4Z",
    fill: "#d1d7ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryIcon);
export default __webpack_public_path__ + "static/media/diary-icon.ee060bbd08bdfb2e4ce9744d16e038f8.svg";
export { ForwardRef as ReactComponent };